/* @flow */
import React from 'react';

import s from './CounterButton.styl';
import classnames from 'classnames/bind';
const cx = classnames.bind(s);

type Props = {
  count: number,
  children?: any,
  className?: string,
  disabled?: boolean,
};

export const CounterButton = (props: Props) => {
  const { children, count, className, disabled, ...rest } = props;
  return (
    <div
      className={cx('CounterButton', { disabled })}
      {...rest}>
      <button className={cx(s.button, className, { disabled })}>
        {children}
      </button>
      <div className={s.countContainer}>
        <span className={s.count}>{count}</span>
      </div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./web_modules/trustar/components/CounterButton.js